import { Directive, ElementRef, Input, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'th[header]',
})
export class ColumnHeaderDirective implements OnInit, OnDestroy {

  private _el: HTMLElement;

  private queryParamsSubscription: Subscription;

  @Input()
  readonly header: string;

  private _encodedSortProperty;
  @Input()
  set column(name: string) {
    this._encodedSortProperty = encodeURI(name);
  }

  constructor(
    el: ElementRef,
    private router: Router,
    private route: ActivatedRoute) {
    this._el = el.nativeElement;
  }

  ngOnInit() {
    if (this._encodedSortProperty) {
      this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
        const search = params;
        if (search.sort === `${this._encodedSortProperty}.a`) {
          this._el.innerHTML = `
<div class="d-flex cursor-pointer text-left">
  <div class="flex-grow-1">${this.header}</div>
  <div><i class="fas fa-sort-alpha-down"></i></div>
</div>`;
        } else if (search.sort === `${this._encodedSortProperty}.d`) {
          this._el.innerHTML = `
<div class="d-flex cursor-pointer text-left">
  <div class="flex-grow-1">${this.header}</div>
  <div><i class="fas fa-sort-alpha-up"></i></div>
</div>`;
        } else {
          this._el.innerHTML = `<div class="d-flex cursor-pointer text-left">${this.header}</div>`;
        }
      });
    } else {
      this._el.innerHTML = `<div class="d-flex">${this.header}</div>`;
    }
  }

  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  @HostListener('click')
  onClick(): void {
    if (this._encodedSortProperty) {

      const search = this.route.snapshot.queryParams;
      let sort = `${this._encodedSortProperty}.a`;

      if (search.sort === `${this._encodedSortProperty}.a`) {
        sort = `${this._encodedSortProperty}.d`;
      }

      this.router.navigate(['.'], {
        relativeTo: this.route,
        queryParams: Object.assign({},
          search, {
            sort
          })
      });
    }
  }
}
